module.exports = __webpack_public_path__ + "static/media/8D.5f81e325.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8D.svg
// module id = 78
// module chunks = 0